import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderButton } from '../../interfaces/header-button';
import { NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { UserService } from '../../services/user.service';
import { HeaderSignalService } from '../../services/header-signal.service';

@Component({
    selector: 'mobilize-page-header',
    imports: [
        NgClass
    ],
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent implements OnInit {

	@Input() title = '';
	@Input() section = '';
    @Input() button?: HeaderButton;
    @Input() reverse?: boolean = false;

    private _router = inject(Router);
    private _user = inject(UserService);
    private _headerSignalService = inject(HeaderSignalService); // Inject the service


    user!: any;
    userLoaded = false;

    ngOnInit() {
        this._user.userData().subscribe(data => {
            this.user = data;
            this.userLoaded = true;
        })
    }

    openMenu() {
        this._headerSignalService.emitEvent('menuOpen');
    }

    buttonAction() {
        switch (this.button?.action) {
            case 'route':
                this._router.navigateByUrl(this.button.actionData.route);
                break;
        }
    }
}
